import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  Container,
  ContentContainer,
  FirstItem,
  LastTableItem,
  StatusTableItem,
  EmptyTable,
  StatusTableContainer,
  ErrorTitle,
  ClientModalContainer,
} from './ClientsPage.styles';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import Table from '../../components/Table/Table';
import TableItem from '../../components/Table/TableItem';

import { ReactComponent as RightChevron } from '../../assets/icons/chevronRight.svg';
import ClientDetails from './ClientDetails/ClientDetails';
import { useDispatch, useSelector } from 'react-redux';
import { createClientByVendor, getClientsForVendor } from '../../store/slice/vendor/asyncThunks';
import {
  selectAllVendorClients,
  selectAllVendorClientsData,
  selectCreateClientByVendorPending,
  selectVendorsInfo,
} from '../../store/slice/vendor/slice';
import { acceptFormatter, dateFormatter, firstLetterCapitalized } from '../../utils/utils';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Waveform } from '@uiball/loaders';
import debounce from 'lodash.debounce';
import ModalComponent from '../../components/Modal/ModalComponent';
import {
  HashtagContainer,
  HashtagName,
  HashtagsContainer,
  IconPosition,
  StyledInput,
} from './ClientDetails/ClientDetails.styles';
import PhoneNumberInput from '../../components/utils/PhoneInput/PhoneNumberInput';
import { ReactComponent as Calendar } from '../../assets/icons/date.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CLIENT_STATUSES } from '../../utils/constants';
import Select from 'react-select';
import { ReactComponent as X } from '../../assets/icons/closeModal.svg';
import { isValidPhoneNumber } from 'libphonenumber-js';
import HamburgerSidebar from '../../components/HamburgerSidebar/HamburgerSidebar';
import { TableBodyRow } from '../../components/Table/Table.styles';
import { notifyErrorLeft, notifyInfo } from '../../utils/notify';

const tableHeader = [
  {
    label: 'Client Name',
    sortable: true,
    key: 'ClientName',
  },
  {
    label: 'Wedding Date',
    sortable: true,
    key: 'date',
  },
  {
    label: 'Balance Due',
    sortable: true,
    key: 'balanceDue',
  },
  {
    label: 'Total Amount',
    sortable: true,
    key: 'totalAmount',
  },
  {
    label: 'Status',
    sortable: true,
    key: 'status',
  },
  {
    label: '',
    sortable: true,
    key: 'chevron',
  },
];

const ClientsPage = () => {
  const dispatch = useDispatch();
  let [searchParams] = useSearchParams();
  const pageParam = searchParams.get('page');
  const screenParam = searchParams.get('screen');
  const search = searchParams.get('search');

  const [searchValue, setSearchValue] = useState('');
  //const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();
  const [id, setId] = useState('');
  const clients = useSelector(selectAllVendorClientsData);
  const { total, perPage } = useSelector(selectAllVendorClients);
  const vendorsInfo = useSelector(selectVendorsInfo);
  const createClientByVendorPending = useSelector(selectCreateClientByVendorPending);

  const [isNewClientModalOpen, setIsNewClientModalOpen] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [husbandName, setHusbandName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState({ value: '', formattedValue: '' });
  const [weddingDate, setWeddingDate] = useState();
  const [note, setNote] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const [hashtags, setHashtags] = useState([]);
  const [hashtagInput, setHashtagInput] = useState('');
  const [error, setError] = useState('');

  const clientStatuses = CLIENT_STATUSES;

  const datePickerRef = useRef(null);

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const changePage = page => {
    if (search) {
      navigate({
        pathname: '/clients',
        search: `?page=${page}&search=${search}`,
      });
    } else {
      navigate({
        pathname: '/clients',
        search: `?page=${page}`,
      });
    }
    dispatch(getClientsForVendor({ page: page, ...(search && { search }) }));
  };

  const onClientDetails = id => {
    setId(id);
    navigate({
      pathname: '/clients',
      search: `?screen=details&id=${id}&tab=contracts`,
    });
  };

  useEffect(() => {
    dispatch(
      getClientsForVendor({
        page: pageParam,
        ...(search && { search }),
      }),
    )
      .unwrap()
      .then(() => {})
      .catch(err => {
        console.log(err);
      });
  }, [dispatch, pageParam, search]);

  // useEffect(() => {
  //   setCurrentPage(+pageParam);
  //   if (pageParam > 0) {
  //     dispatch(
  //       getClientsForVendor({
  //         page: pageParam,
  //         ...(search && { search }),
  //       }),
  //     );
  //   }
  // }, [dispatch, search, pageParam]);

  useEffect(() => {
    if (search) {
      setSearchValue(search);
    } else {
      setSearchValue('');
    }
  }, [search]);

  const changeHandler = useCallback(
    text => {
      navigate({
        pathname: '/clients',
        search: `?page=1&search=${text}`,
      });
    },
    [navigate],
  );

  const debouncedChangeHandler = useMemo(() => debounce(changeHandler, 300), [changeHandler]);

  const handleSearch = e => {
    setSearchValue(e.target.value);
    debouncedChangeHandler(e.target.value);
  };

  const openModal = () => {
    setIsNewClientModalOpen(true);
  };
  const closeModal = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setNote('');
    setPhoneNumber({ value: '', formattedValue: '' });
    setWeddingDate();
    setStatus(null);
    setIsNewClientModalOpen(false);
    setHashtags([]);
    setHashtagInput('');
    setError('');
    setHusbandName('');
  };

  const handleAddHashtag = hashtag => {
    setHashtagInput('');
    const founded = hashtags.find(item => item.name === hashtag);
    if (!founded && hashtag) {
      setHashtags(prev => {
        return [{ name: hashtag }, ...prev];
      });
    }
  };
  const handleRemoveHashtag = hashtag => {
    let filteredArray = hashtags.filter(item => item.name !== hashtag.name);
    setHashtags(filteredArray);
  };

  const handleCreateClient = () => {
    const data = {
      firstName,
      lastName,
      phoneNumber: phoneNumber.value,
      ...(email && { email }),
      ...(weddingDate && { dateOfWedding: weddingDate.getTime() }),
      ...(note && { note }),
      ...(husbandName && { groomName: husbandName }),
      hashtags,
      status: status.value,
    };
    dispatch(createClientByVendor(data))
      .unwrap()
      .then(data => {
        closeModal();
        notifyInfo(data.message);
      })
      .catch(err => {
        notifyErrorLeft(err.message);
        setError(err.message);
      });
  };
  return (
    <Container>
      <Sidebar />
      <HamburgerSidebar />
      <ContentContainer>
        <Header
          title={!screenParam && 'Client Management'}
          search={!screenParam}
          back={screenParam === 'details'}
          setSearchValue={handleSearch}
          searchValue={searchValue}
          onBack={() =>
            navigate({
              pathname: '/clients',
              search: `?page=1`,
            })
          }
          buttonAdd={!screenParam}
          buttonText={'Add Client'}
          onButtonClick={openModal}
        />
        {!screenParam &&
          (!vendorsInfo.getClientsForVendorPending ? (
            <Table
              headerInformation={tableHeader}
              totalCount={total}
              currentPage={+pageParam}
              setPage={changePage}
              perPage={perPage}
              noDataContent="No data"
              dataLoading={false}
              chevron
              lastColumnAligned>
              {clients.map(row => {
                return (
                  <TableBodyRow
                    key={row.id}
                    onClick={() => {
                      onClientDetails(row.id);
                    }}>
                    <FirstItem showImage={true} data={`${row.firstName} ${row.lastName}`} image={row.profilePhoto} />
                    <TableItem data={row.weddingDate && `${dateFormatter(row.weddingDate)}`} />
                    <TableItem data={row.balanceDue ? `$${row.balanceDue.toFixed(2)}` : `$0`} />
                    <TableItem data={row.totalAmount ? `$${row.totalAmount.toFixed(2)}` : `$0`} />
                    <StatusTableContainer>
                      <StatusTableItem $completed={row.status === 'completed' && true}>
                        {`${firstLetterCapitalized(acceptFormatter(row.status))}`}
                      </StatusTableItem>
                    </StatusTableContainer>
                    <LastTableItem data={<RightChevron />} $chevron />
                  </TableBodyRow>
                );
              })}
            </Table>
          ) : (
            <EmptyTable>
              <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
            </EmptyTable>
          ))}
        {screenParam === 'details' && <ClientDetails id={id} />}
      </ContentContainer>
      <ModalComponent
        isOpen={isNewClientModalOpen}
        onClose={closeModal}
        title={'New Client'}
        onCreate={handleCreateClient}
        createDisabled={!firstName || !lastName || !isValidPhoneNumber(phoneNumber.formattedValue) || !status}
        cancelDisabled={createClientByVendorPending}
        loading={createClientByVendorPending}>
        <ClientModalContainer>
          <StyledInput placeholder="First Name" value={firstName} onChange={n => setFirstName(n.target.value)} />
          <StyledInput placeholder="Last Name" value={lastName} onChange={n => setLastName(n.target.value)} />
          <PhoneNumberInput wrapperWidth={'100%'} phone={phoneNumber} setPhone={setPhoneNumber} />
          <StyledInput placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
          <StyledInput placeholder="Fiance’s Name" value={husbandName} onChange={n => setHusbandName(n.target.value)} />
          <div className="border-bottom">
            <DatePicker
              placeholderText="Wedding Date"
              className="date-picker"
              selected={weddingDate && weddingDate}
              calendarClassName="scale"
              dateFormat="MMMM d, yyyy"
              minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
              onChange={date => setWeddingDate(date)}
              ref={datePickerRef}
            />
            <IconPosition onClick={handleIconClick}>
              <Calendar />
            </IconPosition>
          </div>
          <StyledInput placeholder="Notes" value={note} onChange={n => setNote(n.target.value)} />
          <StyledInput
            type="text"
            placeholder="Write hashtag"
            onChange={h => setHashtagInput(h.target.value)}
            value={hashtagInput}
            onKeyDown={e => e.key === 'Enter' && handleAddHashtag(e.target.value)}
          />
          <HashtagsContainer>
            {hashtags.map((item, index) => (
              <HashtagContainer key={index} onClick={() => handleRemoveHashtag(item)}>
                <HashtagName>{`#${item.name}`}</HashtagName>
                <X width={15} height={15} />
              </HashtagContainer>
            ))}
          </HashtagsContainer>
          <Select
            theme={theme => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: '#f1e4df',
                primary: '#f1e4df',
                primary75: '#f1e4df',
                primary50: '#f1e4df',
              },
            })}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                boxShadow: state.isFocused ? 'none' : 'none',
                borderColor: state.isFocused ? '#f1e4df !important' : 'rgba(0,0,0,0.15)',
              }),

              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isFocused && '#F1E4DF',

                color: 'black',
              }),
            }}
            options={clientStatuses}
            placeholder={'Status'}
            onChange={c => setStatus(c)}
            value={status}
          />
          <ErrorTitle>{error}</ErrorTitle>
        </ClientModalContainer>
      </ModalComponent>
    </Container>
  );
};

export default ClientsPage;
